const ENVIRONMENTS = {
  production: 'production',
  development: 'development',
  test: 'test',
};

export { ENVIRONMENTS };
